/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { List } from 'immutable'
import { AutoTaskActionTypes } from '../../action/auto_action/AutoTaskActions'
import { AutoActionTaskState } from '../state/AutoActionTaskState'

class AutoActionTasksStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return List([])
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case AutoTaskActionTypes.fetchAll:
        const tasks = payload.tasks.map(task => {
          return new AutoActionTaskState(task)
        })
        return List(tasks)
      default:
        return state
    }
  }
}

export default new AutoActionTasksStore()
